// React
import React, {Component} from 'react';
// Components
import {Button, Input, SelectSimple, Copy} from '@components/Input';
import {KeyboardTimePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import {Chip, Divider, FormHelperText, IconButton, Switch, CircularProgress} from "@material-ui/core";
import {AlertInfo} from "@components/Alert";
import DateFnsUtils from "@date-io/date-fns";
// Styles
import './styles.scss';
// SVG
import {clockSvg, deleteSvg} from "@assets";

export default class ElementsCustom extends Component {

    handleInput = () => {
        const {
            t,
            type,
            element_type,
            select_value,
            multiline,
            updateElement,
            element,
            elements,
            input_type,
            disabled,
            code,
            conditional,
            loading,
            helper,
            inputType,
            warning,
            alert
        } = this.props;
        switch (input_type) {
            case 'input':
                return (
                    <Input
                        placeholder={t(`elements.custom.${type}.card.${element_type}.placeholder`)}
                        multiline={multiline}
                        value={element}
                        helper={helper}
                        inputType={inputType}
                        disabled={disabled}
                        warning={warning}
                        onChange={(e) => updateElement(e, element_type, input_type)}
                    />
                )
            case 'input_copy':
                return (
                    <div className={"elements_custom__copy"}>
                        <Input
                            placeholder={t(`elements.custom.${type}.card.${element_type}.placeholder`)}
                            multiline={multiline}
                            value={element}
                            disabled={disabled}
                            onChange={(e) => updateElement(e, element_type)}
                        />
                        <Copy copyText={element}/>
                    </div>
                )
            case 'select':
                return (
                    <SelectSimple
                        valueSelected={element ? element : false}
                        placeholder={t(`elements.custom.${type}.card.${element_type}.placeholder`)}
                        items={elements}
                        onSelect={(e) => updateElement(e, element_type, input_type)}
                        className={"select_secondary"}
                        type={element_type.includes("status") ? "status" : element_type === "whatsapp_phone" ? "whatsapp_phone" : element_type === "mode" ? "mode" : "normal"}
                        disabled={disabled}
                        value={select_value}
                        t={t}
                    />
                )
            case 'select_with_conditional':
                return (
                    <div className={"elements_custom__code"}>
                        {
                            (element || !alert && !element) &&
                                <SelectSimple
                                    valueSelected={element ? t(`elements.custom.${type}.card.${element_type}.conditional.${element}.selector`) : false}
                                    placeholder={t(`elements.custom.${type}.card.${element_type}.placeholder`)}
                                    items={elements}
                                    onSelect={(e) => updateElement(e, element_type, input_type)}
                                    className={"select_secondary"}
                                    type={element_type ?? "normal"}
                                    disabled={disabled}
                                    value={select_value}
                                    t={t}
                                />
                        }
                        {
                            !element && alert &&
                            <AlertInfo text={t(`elements.custom.${type}.card.${element_type}.placeholder`)}/>
                        }
                        {
                            conditional?.element_conditional &&
                            <React.Fragment>
                                {
                                    conditional.type === "input" &&
                                    <Input
                                        placeholder={t(`elements.custom.${type}.card.${element_type}.conditional.${element}.placeholder`)}
                                        value={conditional.element}
                                        onChange={(e) => updateElement(e, conditional.element_type, element)}
                                    />
                                }
                                {
                                    conditional.type === "select_with_conditionals" &&
                                    <React.Fragment>
                                        {
                                            element === "quick_reply" &&
                                            <React.Fragment>
                                                {conditional?.element_actions?.map((button, i) => {
                                                    return (
                                                        <React.Fragment key={i}>
                                                            <div className={"elements_custom__code_action"}>
                                                                <Input
                                                                    placeholder={t(`elements.custom.${type}.card.${element_type}.conditional.${element}.text`)}
                                                                    value={button.text}
                                                                    disabled={conditional.disabled && ["webhook", "groups"].includes(type)}
                                                                    onChange={(e) => updateElement(e, element, "update", i)}
                                                                />
                                                                {
                                                                    conditional?.element_actions.length !== 1 && !["webhook", "groups"].includes(type) &&
                                                                    <IconButton style={{backgroundColor: 'transparent'}}
                                                                                onClick={(e) => updateElement(e, element, "delete", i)}
                                                                                disableRipple
                                                                                disableFocusRipple
                                                                                aria-label="delete">
                                                                        {deleteSvg()}
                                                                    </IconButton>
                                                                }
                                                            </div>
                                                            {["webhook", "groups"].includes(type) &&
                                                            <Input
                                                                placeholder={t(`elements.custom.${type}.card.${element_type}.conditional.${element}.payload`)}
                                                                value={button.payload}
                                                                onChange={(e) => updateElement(e, "payload", "update", i)}
                                                            />}
                                                            {
                                                                i !== conditional?.element_actions.length - 1 &&
                                                                <Divider/>
                                                            }
                                                        </React.Fragment>
                                                    )
                                                })}
                                                {
                                                    !["webhook", "groups"].includes(type) &&
                                                    <Button type={"add"}
                                                            disabled={conditional.element_actions_conditional}
                                                            onClick={(e) => updateElement(e, element, "add")}
                                                            text={t(`elements.custom.${type}.card.${element_type}.conditional.${element}.add`)}/>
                                                }

                                            </React.Fragment>
                                        }
                                        {
                                            element === "call_to_action" &&
                                            <React.Fragment>
                                                {conditional?.element_actions?.map((button, i) => {
                                                    return (
                                                        <div className={"elements_custom__code_box"} key={i}>
                                                            <div className={"elements_custom__code_box_header"}>
                                                                <SelectSimple
                                                                    valueSelected={button.action ? t(`elements.custom.${type}.card.${element_type}.conditional.${element}.${button.action}.selector`) : false}
                                                                    placeholder={t(`elements.custom.${type}.card.${element_type}.conditional.${element}.${button.action}.placeholder`)}
                                                                    items={conditional.elements}
                                                                    onSelect={(e) => updateElement(e, button.action, "add")}
                                                                    className={"select_primary"}
                                                                    type={button.action ?? "normal"}
                                                                    disabled={conditional.disabled}
                                                                    value={""}
                                                                    t={t}
                                                                />
                                                                {
                                                                    !conditional.element_actions_conditional &&
                                                                    <IconButton style={{backgroundColor: 'transparent'}}
                                                                                onClick={(e) => updateElement(e, button.action, "delete", i)}
                                                                                disableRipple
                                                                                disableFocusRipple
                                                                                aria-label="delete">
                                                                        {deleteSvg()}
                                                                    </IconButton>
                                                                }
                                                            </div>
                                                            <div className={"elements_custom__code_box_content"}>
                                                                <Input
                                                                    type={"secondary"}
                                                                    placeholder={t(`elements.custom.${type}.card.${element_type}.conditional.${element}.${button.action}.text`)}
                                                                    value={button.text}
                                                                    disabled={["webhook", "groups"].includes(type)}
                                                                    onChange={(e) => updateElement(e, button.action, "update_text", i)}
                                                                />
                                                                <Input
                                                                    type={"secondary"}
                                                                    placeholder={t(`elements.custom.${type}.card.${element_type}.conditional.${element}.${button.action}.action`)}
                                                                    value={button.action === 'website' ? button.url : button[button.action]}
                                                                    disabled={["webhook", "groups"].includes(type)}
                                                                    onChange={(e) => updateElement(e, button.action, "update_action", i)}
                                                                />
                                                            </div>
                                                        </div>
                                                    )
                                                })}
                                            </React.Fragment>
                                        }
                                    </React.Fragment>

                                }
                            </React.Fragment>
                        }
                    </div>
                )
            case 'select_with_inputs_code':
                return (
                    <div className={"elements_custom__code"}>
                        <SelectSimple
                            valueSelected={element ? element : false}
                            placeholder={t(`elements.custom.${type}.card.${element_type}.placeholder`)}
                            items={elements}
                            onSelect={(e) => updateElement(e, element_type)}
                            className={"select_secondary"}
                            type={"normal"}
                            disabled={disabled}
                            value={select_value}
                            t={t}
                        />
                        {
                            code &&
                            <span className={"elements_custom__code_content"}>{code}</span>
                        }
                        {
                            conditional.params.length > 0 &&
                            conditional.params.map((param, i) => {
                                return (
                                    <div className={"elements_custom__code_param"} key={i}>
                                        <div>
                                            <label>{t(`elements.custom.${type}.card.${element_type}.conditional.params.title`)} {i + 1}</label>
                                            <Input
                                                placeholder={t(`elements.custom.${type}.card.${element_type}.conditional.params.text`)}
                                                value={param}
                                                onChange={(e) => updateElement(e, "params", "update", i)}
                                            />
                                        </div>
                                        {
                                            i !== conditional?.params.length - 1 &&
                                            <Divider/>
                                        }
                                    </div>
                                )
                            })
                        }
                    </div>
                )
            case 'time_select':
                return (
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardTimePicker
                            className={`input-primary ${disabled ? 'time_picker_disable' : ""}`}
                            format="yyyy/MM/dd HH:mm:ss"
                            ampm={false}
                            value={element}
                            onChange={(e) => updateElement(e, element_type)}
                            disablePast
                            keyboardIcon={clockSvg()}
                        />
                    </MuiPickersUtilsProvider>
                )
            case 'select_with_code':
                return (
                    <div className={"elements_custom__code"}>
                        <SelectSimple
                            valueSelected={element ? element : false}
                            placeholder={t(`elements.custom.${type}.card.${element_type}.placeholder`)}
                            items={elements}
                            onSelect={(e) => updateElement(e, element_type)}
                            className={"select_secondary"}
                            type={"normal"}
                            disabled={disabled}
                            value={select_value}
                            t={t}
                        />
                        {
                            code &&
                                <span className={"elements_custom__code_content"}>{code}</span>
                        }
                    </div>
                )
            case 'input_zendesk':
                return (
                    <div className={"elements_custom__zendesk"}>
                        <Input
                            placeholder={t(`elements.custom.${type}.card.${element_type}.placeholder`)}
                            multiline={multiline}
                            value={element}
                            disabled={disabled}
                            warning={warning}
                            onChange={(e) => updateElement(e, element_type, input_type)}
                        />
                        <span>.zendesk.com</span>
                    </div>
                )
            case 'input_with_tags':
                return (
                    <div className={"elements_custom__tags"}>
                        <div>
                            <Input
                                type="primary"
                                value={element}
                                onChange={(e) => updateElement(e, 'add', element_type)}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        updateElement(e, 'enter', element_type)
                                    }
                                }}
                                placeholder={t(`elements.custom.${type}.card.${element_type}.placeholder`)}
                            />
                            <FormHelperText>{t(`elements.custom.${type}.card.tags.helper`)}</FormHelperText>
                        </div>
                        <div className="chips">
                            {elements.map((el, i) => {
                                return (
                                    <Chip
                                        key={i}
                                        label={el}
                                        onDelete={(e) => updateElement(e, 'delete', element_type, el, i)}
                                    />
                                );
                            })}
                        </div>
                    </div>
                )
            case 'switch':
                return (
                    <Switch
                        checked={(element)}
                        onChange={(e) => {
                            updateElement(e, element_type, input_type)
                        }}
                    />
                )
            case 'button':
                return (
                    element ? (
                        <Button type={"primary"}
                                disabled
                                text={t(`elements.custom.${type}.card.${element_type}.button_active`)}/>
                    ) : (
                        loading ?
                            <Button type={"primary"} disabled text={<CircularProgress size={21}/>}/> :
                            <Button type={"primary"}
                                    text={t(`elements.custom.${type}.card.${element_type}.button_activated`)}
                                    disabled={disabled}
                                    onClick={(e) => updateElement(e, 'element_type')}/>

                    )
                )
            case 'string':
                return <div className={"elements_custom__string"}>
                    <span>{element}</span>
                </div>
            default:
                return (
                    <span className={"elements_custom__default"}>{element}</span>
                )
        }
    }

    render() {
        const {t, type, element_type, element_translate, className, optional} = this.props;
        return (
            <div className={`elements_custom ${className ?? ''}`}>
                <div className={"elements_custom__info"}>
                    <span
                        className={"elements_custom__title"}>{t(`elements.custom.${type}.card.${element_type}.title`)}
                        {optional && <div className={"elements_custom__optional"}>Optional</div>}
                    </span>
                    {
                        element_translate ? (
                            <span
                                className={"elements_custom__description"}>{t(`elements.custom.${type}.card.${element_type}.description`, {timezone: element_translate})}</span>
                        ) : (
                            <span
                                className={"elements_custom__description"}>{t(`elements.custom.${type}.card.${element_type}.description`)}</span>
                        )
                    }
                </div>
                {this.handleInput()}
            </div>
        );
    }
}